<template>
  <div class="match">
    <van-pull-refresh v-model="is_refresh" @refresh="onRefresh" style="margin-bottom: 50px">
      <van-list class="list-wrap" v-model="is_loading"
                :finished="is_load_finished"
                :immediate-check="false"
                finished-text="没有更多了"
                :error.sync="is_error"
                error-text="请求失败，点击重新加载"
                @load="onLoad">
        <!--<van-cell title="最新方案" is-link value="更多"></van-cell>-->
        <div v-for="(xitem, xindex) in list" :key="xindex">
          <van-sticky>
            <div class="list-title weball-font-14">{{title_list[xindex]}}</div>
          </van-sticky>
          <van-cell class="list-cell"  v-for="(yitem, yindex) in xitem" :key="yindex" v-on:click="go_detail(yitem.match_id)" >
            <van-row  type="flex" justify="start" align="ceter" >
              <van-col span="5">
                <div class="van-hairline--right weball-padding-x-5" >
                  <!--<div class="weball-font-14" style="color: #333;">{{yitem.cstatus}}</div>-->
                  <div v-if="yitem.status===0" style="color: #333;">{{yitem.cstatus}}</div>
                  <van-tag v-else-if="yitem.status===1" type="primary">{{yitem.cstatus}}</van-tag>
                  <van-tag v-else type="danger" >{{yitem.cstatus}}</van-tag>
                  <div class="weball-font-12 weball-ellipsis" style="color: #888;">{{yitem.competitionName + yitem.stage}}</div>
                </div>
              </van-col>
              <van-col span="12" class="weball-padding-x-5">
                <div><span class="weball-font-14 weball-font-color-highlight weball-ellipsis">主：</span>{{yitem.homeTeamName}}</div>
                <div><span class="weball-font-14 weball-font-color-main weball-ellipsis">客：</span>{{yitem.awayTeamName}}</div>
              </van-col>
              <van-col span="3">
                <div class="weball-padding-x-5" style="text-align: right">
                  <div>{{yitem.homeScore}}</div>
                  <div>{{yitem.awayScore}}</div>
                </div>
              </van-col>

              <van-col span="4" class="" style="display: flex;flex-direction: column;justify-content: center;align-items: center;padding-left: 5px">
                <div class="weball-font-12 weball-font-color-war" style="text-align: right;">{{yitem.project_num>0?yitem.project_num+"个方案" : ""}}</div>
              </van-col>
            </van-row>

          </van-cell>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-tabbar   @change=""  route>
      <van-tabbar-item icon="home-o" replace :to="werouter.index.path">首页</van-tabbar-item>
      <van-tabbar-item icon="hot-o" replace :to="werouter.author.path">大神</van-tabbar-item>
      <van-tabbar-item icon="medal-o" replace :to="werouter.match.path">赛事</van-tabbar-item>
      <van-tabbar-item icon="chat-o" replace :to="werouter.message.path">消息</van-tabbar-item>
      <van-tabbar-item icon="user-circle-o" replace :to="werouter.mine.path">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
    export default {
        name: 'match',
        data() {
            return {
                select_value: '',
                images: [
                    'https://img.yzcdn.cn/vant/apple-1.jpg',
                    'https://img.yzcdn.cn/vant/apple-2.jpg'
                ],
                page: 0,
                list: [],
                title_list:[],
                is_error: false,
                is_refresh: false,
                is_loading: false,
                is_load_finished: false
            }
        },
        created: function () {
            this.page = 1;
            this.getData(this.page, false)
        },
        methods: {
            onRefresh() {
                this.page = 1;
                this.is_load_finished = false;
                this.getData(this.page, true)
            },
            onLoad() {
                this.page++;
                this.getData(this.page, false);

            },
            transData:function(list){
                let that = this;
                this.weutil.forEach(list, function (item) {
                    let temp_key = item.date + " " + item.week
                    let index = that.title_list.indexOf(temp_key);
                    if(index>=0){//存在
                       that.list[index].push(item);
                    }
                    else{
                       that.title_list.push(temp_key);
                       that.list.push([item]);
                    }
                });
            },
            getData: function (page, refresh) {
                let that = this;
                this.weapi.request({
                    url: 'match_list',
                    method: 'get',
                    params: {page:page},
                }).then(res => {
                    if (res.data.code === '200') {
                        let _list = res.data.data.list;
                        if (refresh) {
                            that.$toast('刷新成功！');
                            that.is_refresh = false;
                        }
                        if (that.page <= 1) {
                            that.list = [];
                            that.is_load_finished = false;
                            that.title_list = [];
                        }
                        that.transData(_list);
                        if (res.data.data.end) {
                            that.is_load_finished = true;
                        }
                    }
                    else {
                        that.is_refresh = false;
                        that.is_error = true;
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                    that.is_refresh = false;
                    that.is_error = true;
                }).finally(function (response) {
                    that.is_loading = false;
                })
            },
            go_detail: function (ID) {
                this.$router.push({ name: this.werouter.matchdetail.name, params: { match_id: ID } })
            }
        }
    }
</script>
<style>
  .match .list-wrap{
    margin: 0 ;
  }
  .match .list-cell{
    padding: 10px 5px;
  }
  .match .list-title{
    padding: 10px;
    color: #333;
    font-weight: 600;
    background-color: #f5f6f8;
  }

</style>
